<template>
  <Teleport to="body">
    <ModalTemplate
      v-if="open"
      :id="id"
      :title="title"
      @update-header-height="handleUpdateHeaderHeight"
      @closed="handleModalClosed"
    >
      <template #header>
        <ModalViewerCategoryHeaderNav
          v-if="isHeaderNavVisible && contents.length > 1"
          :contents="contents"
        />
        <ModalViewerCategoryHeaderSubNav
          v-if="isHeaderNavVisible && children.length > 1"
          :children="children"
        />
      </template>
      <template #content>
        <ModalViewerCategoryContents :offset-top="headerHeight" />
      </template>
    </ModalTemplate>
  </Teleport>
</template>

<script lang="ts" setup>
const { libraryBookId, categoryTrialContent } = inject(INJECT_CATEGORY_PAGE);

const headerHeight = ref<number>(0);

const handleUpdateHeaderHeight = (height: number) => {
  headerHeight.value = height;
};

const open = ref(false);

const { categorySlug } = useModalCategoryRouter();

const route = useRoute();

const {
  options: { history },
  back,
} = useRouter();

const modalCategory = useModalCategory(libraryBookId, categoryTrialContent);

const { isHeaderNavVisible, contents, children, title } = modalCategory;

provide(INJECT_MODAL_CATEGORY, modalCategory);

const id = computed(() => (categorySlug.value ? categorySlug.value : null));

const dialogLockedContent = useDialogLockedContent();

const handleModalClosed = () => {
  modalCategory.unload();
  dialogLockedContent.close();
  open.value = false;
};

const openDialogLockedContent = () => {
  dialogLockedContent.open(
    'default',
    null,
    () => {
      if (!modalCategory.isLoaded.value) return;
      modalCategory.unload();
      if (history?.state?.back && history?.state?.back === route.path) {
        back();
      } else {
        navigateTo(route.path, { replace: true });
      }
    },
    modalCategory.content
      ? useAppEventShare(
          EventAssociatedModel.ContentLockScreen,
          (modalCategory.content as any)?.id,
          (modalCategory.content as any)?.contentType
        )
      : null
  );
};

const handleModalSlug = async (slug) => {
  await modalCategory.load(slug);
  if (modalCategory.isLocked.value) {
    openDialogLockedContent();
  } else {
    open.value = true;
  }
};

watch(
  () => categorySlug.value,
  (slug) => {
    if (slug) {
      handleModalSlug(categorySlug.value);
    } else {
      dialogLockedContent.close();
    }
  }
);

if (categorySlug.value) {
  handleModalSlug(categorySlug.value);
}

onUnmounted(() => {
  dialogLockedContent.close();
  open.value = false;
  modalCategory.unload();
});
</script>
